//页面主体部分三个组件 头、侧边栏、页面内容
import vHead from '../header/index.vue'   //头部
import vFooter from '../footer.vue'   //尾部
import vMain from '../main/index.vue'     //页面内容
export default {
	name:'home',
	components:{ //注册组件
  		vHead,
  		vFooter,
  		vMain,
    },
}